import form from "./form";

const {
  formField: { title, url },
} = form;

const initialValues = {
  [title.name]: "",
  [url.name]: "",
};

export default initialValues;
